/**
 * Rascunho TEMPORÁRIO (só no browser, sessionStorage) dos dados que o usuário
 * digita na etapa "Datos de la visita" enquanto navega para frente/trás no
 * wizard. NÃO vai para o Firebase — é limpo ao concluir ou cancelar o caso
 * (ChildCaseService.cancelCaseRegistry).
 */
export interface VisitDraft {
    date?: number | null; // timestamp (ms) da data da visita, ao meio-dia local
    weight?: number;
    pounds?: number;
    height?: number;
    feet?: number;
    inch?: number;
    muac?: number;
    weightSelector?: string;
    heightSelector?: string;
    showMeasureInputs?: boolean;
    showOnlyMUACMeasure?: boolean;
}

export class VisitDraftUtil {
    private static readonly PREFIX = 'nm-visit-draft:';

    private static key(token: string): string {
        return VisitDraftUtil.PREFIX + (token || 'anon');
    }

    static save(token: string, draft: VisitDraft): void {
        try {
            sessionStorage.setItem(VisitDraftUtil.key(token), JSON.stringify(draft));
        } catch {
            // sessionStorage indisponível (modo privado, quota) — ignora
        }
    }

    static load(token: string): VisitDraft | null {
        try {
            const raw = sessionStorage.getItem(VisitDraftUtil.key(token));
            return raw ? JSON.parse(raw) as VisitDraft : null;
        } catch {
            return null;
        }
    }

    static clear(token: string): void {
        try {
            sessionStorage.removeItem(VisitDraftUtil.key(token));
        } catch {
            // ignora
        }
    }
}
